export const companyData = [
  { image: "/images/levis.png", alt: "Image Not Found" },
  { image: "/images/brand01.jpg", alt: "Image Not Found" },
  { image: "/images/brand02.jpg", alt: "Image Not Found" },
  { image: "/images/brand03.jpg", alt: "Image Not Found" },
  { image: "/images/brand04.jpg", alt: "Image Not Found" },
  { image: "/images/brand05.jpg", alt: "Image Not Found" },
  { image: "/images/brand06.jpg", alt: "Image Not Found" },
  { image: "/images/brand07.jpg", alt: "Image Not Found" },
  { image: "/images/brand08.jpg", alt: "Image Not Found" },
];


export const kidProduct = [
  {
    image: "/images/kidNewArrival/kidsproductimg.webp",
    name: "SASS & BELLE",
    category: "Bamboo Fire Engine Plate",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: true,
    isDiscount:false
  },
  {
    image: "/images/kidNewArrival/kidsproductimg.webp",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: true,
    isDiscount:false
  },
  {
    image: "/images/kidNewArrival/kidsproductimg.webp",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:true
  },
  {
    image: "/images/cards-07.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:false
  },
  {
    image: "/images/cards-04.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:true
  },
  {
    image: "/images/cards-05.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:false
  },
  {
    image: "/images/cards-06.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:false
  },
  {
    image: "/images/cards-07.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:false
  },
  {
    image: "/images/cards-08.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:true
  },
  {
    image: "/images/cards-09.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: true,
    isDiscount:true
  },
  {
    image: "/images/cards-10.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: false,
    isDiscount:false
  },
  {
    image: "/images/cards-11.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "11.71 USD",
    code: "SPEND & SAVE! CODE: SSGLO",
    isActive: true,
    isDiscount:false
  },
];

export const cardsData = [
  {
    image: "/images/cards-01.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-02.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-03.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-07.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-04.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-05.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-06.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-07.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-08.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-09.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-10.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
  {
    image: "/images/cards-11.jpg",
    name: "Huzaifa Ali",
    category: "Brand to Love",
    footer: "Shop Now",
  },
];

export const Menu = [
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },

  {
    image: "/images/newarrival02.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },

  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },

  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },

  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
  {
    image: "/images/newarrival01.webp",
    name: "maggi",
    category: "Infant Badge Of Sports Summer",
    price: "12.34 USD",
  },
];

export const state = [
  { image: "/images/sliderimg1.png", alt: "Image Not Found" },
  { image: "/images/sliderimg2.png", alt: "Image Not Found" },
  { image: "/images/sliderimg3.png", alt: "Image Not Found" },
  { image: "/images/sliderimg4.png", alt: "Image Not Found" },
  { image: "/images/sliderimg5.png", alt: "Image Not Found" },
  { image: "/images/sliderimg6.png", alt: "Image Not Found" },
  { image: "/images/sliderimg7.png", alt: "Image Not Found" },
  { image: "/images/sliderimg8.png", alt: "Image Not Found" },
  { image: "/images/sliderimg1.png", alt: "Image Not Found" },
];

export const carouselData = [
  { image: "/images/module1.jpg" },
  { image: "/images/module2.jpg" },
  { image: "/images/module3.jpg" },
  { image: "/images/module1.jpg" },
  { image: "/images/module2.jpg" },
  { image: "/images/module3.jpg" },
];
